module.exports = __webpack_public_path__ + "static/img/blyy.238a43c3.png";